import React, { useEffect, useState } from "react";
import axios from "axios";
import Utils from "../../Utils";
import DiscussionList from "./DiscussionList";
import DiscussionForm from "./DiscussionForm";

const AttachmentDiscussion = ({ attachment, psId, canUpload }) => {
  const [loading, setLoading] = useState(true);
  const [threads, setThreads] = useState([]);

  const fetchDiscussion = () => {
    setLoading(true);
    axios
      .get(
        Utils.apiUrl(`photoshoot/attachment/discussion/${attachment.id}`),
        Utils.apiHeaders(),
      )
      .then((res) => {
        setThreads(res.data.data || []);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDiscussion();
  }, [attachment.id]);

  return (
    <div className="mt-4 border rounded-lg p-4 bg-gray-50">
      <h3 className="font-semibold mb-2 flex items-center gap-2">
        <i className="fas fa-comments"></i> Discussion
      </h3>

      {loading ? (
        <div className="text-sm text-gray-500">Loading discussion…</div>
      ) : (
        <DiscussionList threads={threads} />
      )}

      {canUpload() && (
        <DiscussionForm
          psId={psId}
          attachmentId={attachment.id}
          threadId={0}
          onSuccess={fetchDiscussion}
        />
      )}
    </div>
  );
};

export default AttachmentDiscussion;
